export enum SORT_DIRECTION {
  ASC = 'asc',
  DESC = 'desc',
  NONE = 'none',
}

export enum SORT_ARIA_VALUE {
  ASCENDING = 'ascending',
  DESCENDING = 'descending',
  NONE = 'none',
}
